export default "__VITE_ASSET__kBUq2XWp__"